<template>
    <div v-scroll="onScroll" id="root">
        <div id="container">
            <video @contextmenu.prevent id="leftVideo" playsinline autoplay muted loop>
                <source :src="firstUrl" type="video/mp4"/>
            </video>
            <video @contextmenu.prevent id="rightVideo" playsinline autoplay muted loop>
                <source :src="secondUrl" type="video/mp4"/>
            </video>
<!--            <div :style="textTranslate" id="backgroundCaption">{{ backgroundCaption }}</div>-->
        </div>
    </div>
</template>

<script>
	export default {
		name: "DualVideoCard",
		props: {
			source: {
				type: String,
				required: true
			},
			secondSource: {
				type: String,
				required: true
			},
			caption: {
				type: String,
				required: true
			},
			backgroundCaption: {
				type: String,
				required: true
			},
			initialOffset: {
				type: Number,
				default: 1,
			}
		},
		methods: {
			onScroll() {
				this.offsetTop = window.scrollY
			}
		},
		data() {
			return {
				offsetTop: this.initialOffset
			}
		},
		computed: {
			firstUrl() {
				return require('../assets/' + this.source);
			},
			secondUrl() {
				return require('../assets/' + this.secondSource);
			},
			textTranslate() {
				let translateFactor = -1 - (this.offsetTop * 0.001)
				return {
					transform: `translateX(${translateFactor}em)`
				}
			}
		}
	};
</script>

<style lang="scss" src="../styles/dualvideocard.scss" scoped/>